import React from 'react';
import { Link } from 'react-router-dom';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50 to-white" data-testid="datenschutz-page">
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <Link to="/" className="text-rose-600 hover:text-rose-700 text-sm font-semibold" data-testid="datenschutz-back-link">
          ← Zurück zur Startseite / Back to Home
        </Link>

        <h1 className="text-4xl font-serif text-rose-900 mt-6 mb-2">Datenschutzerklärung</h1>
        <p className="text-sm text-gray-500 mb-10">
          Stand: Februar 2026 · gemäß Art. 13 und 14 DSGVO
        </p>

        {/* ============ GERMAN VERSION (legally authoritative) ============ */}
        <section className="space-y-8 text-gray-800 leading-relaxed">

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">1. Verantwortliche</h2>
            <p>
              Verantwortliche im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br /><br />
              Esther Ewebe<br />
              Hauptstraße 3<br />
              86922 Eresing<br />
              Deutschland<br /><br />
              E-Mail: <a href="mailto:info@herenterprisehub.com" className="text-rose-600 hover:underline">info@herenterprisehub.com</a><br />
              Telefon: +49 162 254 1659
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">2. Allgemeines zur Datenverarbeitung</h2>
            <p>
              Wir verarbeiten personenbezogene Daten unserer Nutzerinnen und Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website
              sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung (Art. 6 Abs. 1 lit. a DSGVO),
              zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO), zur Erfüllung rechtlicher Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO) oder aufgrund berechtigter Interessen (Art. 6 Abs. 1 lit. f DSGVO).
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">3. Registrierung und Mitgliedskonto</h2>
            <p>
              Bei der Registrierung verarbeiten wir folgende Daten: Name, E-Mail-Adresse, Passwort (verschlüsselt gespeichert mittels bcrypt), Geschäftsname, optional Branche, Biografie, Profilbild, Standort, Website und Social-Media-Profile.
            </p>
            <p className="mt-2">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung – Bereitstellung der Plattform).<br />
              <strong>Speicherdauer:</strong> bis zur Löschung des Mitgliedskontos. Sie können Ihr Konto jederzeit löschen lassen (siehe Abschnitt 11).
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">4. E-Mail-Verifizierung und transaktionale E-Mails (Resend)</h2>
            <p>
              Für den Versand transaktionaler E-Mails (Verifizierungslinks, Passwort-Zurücksetzungen, Benachrichtigungen, Veranstaltungsbestätigungen) nutzen wir den Dienst <strong>Resend</strong> (Resend, Inc., 2261 Market Street #5039, San Francisco, CA 94114, USA).
              Wir haben Resend in der Region <strong>Ireland (eu-west-1)</strong> konfiguriert; Ihre E-Mail-Inhalte werden somit innerhalb der EU verarbeitet.
            </p>
            <p className="mt-2">
              <strong>Übermittelte Daten:</strong> E-Mail-Adresse, Name, Inhalt der jeweiligen E-Mail.<br />
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an zuverlässiger Zustellung).<br />
              <strong>Datenschutzerklärung Resend:</strong>{' '}
              <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline">
                resend.com/legal/privacy-policy
              </a>
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">5. Bezahlfunktion (Stripe)</h2>
            <p>
              Für die Abwicklung von Mitgliedsbeiträgen und kostenpflichtigen Funktionen nutzen wir <strong>Stripe Payments Europe, Ltd.</strong> (1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland).
              Beim Bezahlvorgang werden Sie zu einer von Stripe gehosteten Checkout-Seite weitergeleitet. <strong>Zahlungsdaten (Kreditkartennummern etc.) werden niemals auf unseren Servern gespeichert.</strong>
            </p>
            <p className="mt-2">
              <strong>Übermittelte Daten:</strong> Name, E-Mail, Rechnungsadresse, Zahlungsinformationen (direkt an Stripe).<br />
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).<br />
              <strong>Datenschutzerklärung Stripe:</strong>{' '}
              <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline">
                stripe.com/de/privacy
              </a>
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">6. Anmeldung über Google und LinkedIn (OAuth)</h2>
            <p>
              Sie können sich optional mit Ihrem Google- oder LinkedIn-Konto anmelden. Hierbei werden Sie zunächst zu Google bzw. LinkedIn weitergeleitet, um die Anmeldung zu bestätigen.
              Nach erfolgreicher Authentifizierung erhalten wir folgende Daten: Name, E-Mail-Adresse, Profilbild und – bei LinkedIn – Berufsangaben (sofern Sie diese geteilt haben).
            </p>
            <p className="mt-2">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung durch Login-Klick) und Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).<br />
              <strong>Datenschutz Google:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline">policies.google.com/privacy</a><br />
              <strong>Datenschutz LinkedIn:</strong> <a href="https://www.linkedin.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline">linkedin.com/legal/privacy-policy</a>
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">7. Hosting und Datenbank</h2>
            <p>
              Die Plattform wird auf Infrastruktur von <strong>Emergent</strong> betrieben. Unsere Datenbank ist eine MongoDB-Instanz, die innerhalb der Emergent-Plattform bereitgestellt wird.
              Mit Emergent besteht ein Auftragsverarbeitungsverhältnis. Die genaue physische Speicherung der Daten klären wir aktiv mit dem Anbieter und ergänzen diese Erklärung entsprechend.
            </p>
            <p className="mt-2">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an zuverlässigem und sicherem Betrieb der Plattform).
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">8. Server-Logs</h2>
            <p>
              Bei jedem Aufruf der Website werden technische Daten in Server-Logs gespeichert: IP-Adresse, Datum und Uhrzeit, aufgerufene URL, Browsertyp, Betriebssystem, Referrer.
              Diese Daten dienen ausschließlich der Sicherstellung des Betriebs, der Abwehr von Angriffen sowie der Fehlerdiagnose.
            </p>
            <p className="mt-2">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an IT-Sicherheit und stabilem Betrieb).<br />
              <strong>Speicherdauer:</strong> in der Regel 14 Tage, bei sicherheits­relevanten Vorfällen länger.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">9. Cookies und ähnliche Technologien</h2>
            <p>
              Wir setzen ausschließlich <strong>technisch notwendige Cookies</strong> ein, um Ihren Login-Status (Authentifizierungs-Token) zu speichern und CSRF-Schutz zu gewährleisten.
              Diese Cookies sind für den Betrieb der Plattform unbedingt erforderlich und können daher nicht abgewählt werden (§ 25 Abs. 2 Nr. 2 TTDSG).
            </p>
            <p className="mt-2">
              Wir verwenden derzeit <strong>keine</strong> Analyse-, Tracking- oder Marketing-Cookies. Sollten wir künftig solche Dienste einsetzen, werden wir vorab Ihre ausdrückliche Einwilligung über einen Cookie-Banner einholen.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">10. Sicherheitsmaßnahmen</h2>
            <p>
              Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten zu schützen:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Verschlüsselte Übertragung via HTTPS/TLS</li>
              <li>Passwort-Hashing mit bcrypt (Industriestandard)</li>
              <li>Konto-Sperrung nach 5 fehlgeschlagenen Login-Versuchen</li>
              <li>XSS- und CSRF-Schutz</li>
              <li>Rate Limiting gegen Brute-Force-Angriffe</li>
              <li>Sicherheits-Audit-Logs</li>
              <li>Validierung von Datei-Uploads</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">11. Ihre Rechte als betroffene Person</h2>
            <p>Nach der DSGVO haben Sie folgende Rechte:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Auskunftsrecht</strong> (Art. 15 DSGVO) – Sie können eine Bestätigung verlangen, ob wir Daten über Sie verarbeiten und eine Kopie dieser Daten erhalten.</li>
              <li><strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO) – Sie können die Berichtigung unrichtiger Daten verlangen.</li>
              <li><strong>Recht auf Löschung</strong> (Art. 17 DSGVO, „Recht auf Vergessenwerden") – Sie können die Löschung Ihrer Daten bzw. Ihres Kontos verlangen.</li>
              <li><strong>Recht auf Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO).</li>
              <li><strong>Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO) – Sie erhalten Ihre Daten in einem strukturierten, maschinenlesbaren Format.</li>
              <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO).</li>
              <li><strong>Beschwerderecht bei einer Aufsichtsbehörde</strong> (Art. 77 DSGVO) – Für uns zuständig ist das Bayerische Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach.</li>
            </ul>
            <p className="mt-3">
              Zur Ausübung Ihrer Rechte genügt eine formlose E-Mail an{' '}
              <a href="mailto:info@herenterprisehub.com" className="text-rose-600 hover:underline">info@herenterprisehub.com</a>.
              Wir werden Ihre Anfrage innerhalb von 30 Tagen bearbeiten.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">12. Datenübermittlung in Drittländer</h2>
            <p>
              Einige unserer Auftragsverarbeiter (insbesondere Resend, Google, LinkedIn) sind US-Unternehmen.
              Die Übermittlung erfolgt auf Grundlage des EU-US Data Privacy Framework bzw. der EU-Standardvertragsklauseln (SCC) gemäß Art. 46 DSGVO.
              Resend wurde von uns in der EU-Region (Ireland) konfiguriert, sodass E-Mail-Inhalte primär innerhalb der EU verarbeitet werden.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-rose-800 mb-3">13. Änderungen dieser Erklärung</h2>
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte Rechtslagen oder bei Änderungen unserer Dienstleistung anzupassen.
              Die jeweils aktuelle Version finden Sie immer unter dieser URL.
            </p>
          </div>
        </section>

        {/* ============ ENGLISH SUMMARY ============ */}
        <hr className="my-12 border-rose-200" />
        <section className="space-y-4 text-gray-700">
          <h2 className="text-2xl font-serif text-rose-900">Privacy Policy (English summary)</h2>
          <p className="text-sm text-gray-600 italic">
            This is a non-binding English summary. The German version above is legally authoritative.
          </p>

          <p>
            We process personal data only as necessary to operate the platform: registration (name, email, password, business info),
            transactional emails via <strong>Resend</strong> (configured in the EU-Ireland region), payments via <strong>Stripe</strong>,
            optional social login via <strong>Google</strong> or <strong>LinkedIn</strong>, and basic server logs for security.
          </p>
          <p>
            We use <strong>only technically essential cookies</strong> (login session + CSRF protection). No analytics or marketing cookies.
          </p>
          <p>
            <strong>Your GDPR rights:</strong> access, rectification, deletion, restriction, portability, objection, and the right to lodge a complaint with the
            Bavarian Data Protection Authority (BayLDA, Promenade 18, 91522 Ansbach). To exercise any right, email{' '}
            <a href="mailto:info@herenterprisehub.com" className="text-rose-600 hover:underline">info@herenterprisehub.com</a>: we respond within 30 days.
          </p>
          <p>
            <strong>Security:</strong> HTTPS/TLS, bcrypt password hashing, account lockout after 5 failed logins, XSS &amp; CSRF protection, rate limiting, security audit logs, file-upload validation.
          </p>
        </section>

        <p className="text-xs text-gray-400 mt-12">
          Hinweis: Diese Datenschutzerklärung wurde nach bestem Wissen erstellt, ersetzt jedoch keine individuelle Rechtsberatung. Bei Änderungen am eingesetzten Tech-Stack (neue Tracker, neue Drittanbieter, neue Hosting-Region) sollten die entsprechenden Abschnitte aktualisiert werden.
        </p>
      </div>
    </div>
  );
};

export default Datenschutz;
